import templateUrl from './app.html';

export const appComponent = {
	templateUrl,

	controller: class AppComponent {
		constructor($state, $window, $timeout, $transitions, HeaderMenusService) {
			'ngInject';

			this.$state = $state;
			this.$window = $window;
            this.$timeout = $timeout;
			this.currentStateName = "";
			this.headerMenusService = HeaderMenusService;
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
		}

		$onInit() {
			this.hideShowAppNavComponents = true;
			this.hideShowSubscribeComponent = true;
			this.hideBreadcrumb = false;

			this.window = angular.element(this.$window);
			this.window.bind('resize', _ => {
				this.$timeout(() => {
					this._onResize.call(this);
				});
			});
			this.features = [];
			this.headerMenusService.getMenuList().then((data) => {
				this.features = data;
			});
		}

		onStateChangeSuccess() {
			this.currentStateName = this.$state.$current.name;
			this.hideShowSubscribeComponent = this.currentStateName === 'Subscribe' ? false : true;
			this.hideBreadcrumb = this.currentStateName === 'tripPlannerResults' ? true : false;
			this.$timeout(() => {
                this._onResize();
            }, 10);
		}

		//******************* PRIVATE METHODS ***************************//

		_onResize() {
			this.hideShowAppNavComponents = (this.currentStateName === 'tripPlannerResults' && this.$window.innerWidth <= 768) ? false : true;
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/app.component.js